type PolygonClipVolume = any;
type BoxClipVolume = any;

export class RestoreHelperService {
    private polygonClipVolumes: PolygonClipVolume[] = [];
    private volumes: BoxClipVolume[] = [];

    setPolygonClipVolumes(volumes: PolygonClipVolume[]) {
        this.polygonClipVolumes = volumes;
    }

    setBoxClipVolumes(volumes: BoxClipVolume[]) {
        this.volumes = volumes;
    }


    loadBoxClipVolumesToScene() {
        this.volumes.forEach(volume => {
            viewer.scene.addVolume(volume);
        });
        this.volumes = [];
    }

    loadPolygonClipVolumesToScene() {
        this.polygonClipVolumes.forEach(volume => {
            viewer.scene.addPolygonClipVolume(volume);
        });
        this.polygonClipVolumes = [];
    }
}
